import { useLazyQuery } from '@apollo/client';
import { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { Flex, Box, Text, Heading, Card, Button } from 'rebass/styled-components'
import styled from 'styled-components';
import { InputNoForm } from '../components/TextInput';
import { GET_CONVERSATIONS, GET_PATIENT_BY_ID } from '../graphql/queries';
import { IConversationListEntry, IGetProviderConversationsInput, IGetProviderConversationsOutput } from '../graphql/types/queries/conversation';
import { IGetProviderPatientByIdInput, IGetProviderPatientByIdOutput } from '../graphql/types/queries/patient';
import { Constants } from '../utils/Constants';
import { sleep } from '../utils/sleep';
import { Communicator } from './messages/Communicator';
import { MessagesList, MessagesListNoSearch, MessagesListSearch } from './messages/MessagesList';
import { ProfileCardSection } from './messages/ProfileCardSection';
import { ProfileCard } from './patient/ProfileCard';
import { PatientEmbed } from './Patient';

interface IMessagesProps {

}

const PatientDetailsFloatingContainer = styled(Flex)`
  display: flex;
  z-index: 10;
  @media screen and (min-width: 1780px) {
    display: none;
  }
`

const PatientDetailsContainer = styled(Flex)`
  display: none;
  
  @media screen and (min-width: 1780px) {
    margin-left: 20px;
    display: flex;
    min-width: 600px;
    max-width: 600px;
  }
`

const Container = styled(Flex)`
  /* padding: ${() => `${Constants.OUTLETS_PADDING_MOBILE}px`}; */
  padding-top: ${() => `${Constants.OUTLETS_PADDING_TOP_MOBILE}px`};
  width: 100%;
  @media screen and (min-width: 68.8125em) {
  padding: ${() => `${Constants.OUTLETS_PADDING}px`};
  padding-right: ${() => `12px`};
  padding-top: ${() => `1px`};
  min-width: ${() => `${Constants.OUTLETS_WIDTH}px`};
  /* padding: ${() => `${Constants.OUTLETS_PADDING}px`};
  padding-top: ${() => `${Constants.OUTLETS_PADDING_TOP}px`};
  min-width: ${() => `${Constants.OUTLETS_WIDTH}px`}; */
  }
`
const DetailContainer = styled(Flex)`
  display: none;
  overflow-y: auto;
  /* padding-bottom: 64px; */
  &.selected {
    display: flex;
    flex: 1;
  }

  @media screen and (min-width: 68.8125em) {
    display: flex;
  }
`;

const ListContainer = styled(Flex)`
  min-width: 300px;
  width: 100%;
  overflow-y: auto;
  &.selected {
    display: none;
  }

  @media screen and (min-width: 68.8125em) {
    width: auto;
    &.selected {
      display: flex;
    }
  }
`;
export const Messages: React.FC<IMessagesProps> = ({ }) => {
  let params = useParams();

  const parseParams = () => {
    if (!params) return
    var result: any = {};
    var p: any = params['*'];
    (p).split("&").forEach(function (part: string) {
      var item = part.split("=");
      if (item.length < 2) {
        result['id'] = decodeURIComponent(item[0])
      } else {
        result[item[0]] = decodeURIComponent(item[1]);
      }
    });
    return result
  }

  const [selectedConversation, setselectedConversation] = useState<IConversationListEntry | null>();
  const [navigatedConversation, setnavigatedConversation] = useState<string | null>();
  const [search, setSearch] = useState<string | null>(null)
  const [tmpSearch, setTmpSearch] = useState<string>('');
  const navigate = useNavigate()
  const [loadPatient, { data: dataPatient, loading: loadingPatient, error: errorPatient }] = useLazyQuery<IGetProviderPatientByIdOutput, IGetProviderPatientByIdInput>(GET_PATIENT_BY_ID, {

  })

  useEffect(() => {
    const parsedParams = parseParams()
    async function setFilters() {
      setTmpSearch(`${parsedParams['target'] ? `${parsedParams['target']}:${parsedParams['id']}` : parsedParams['id']}`)
      await sleep(150)
      setSearch(`${parsedParams['target'] ? `${parsedParams['target']}:${parsedParams['id']}` : parsedParams['id']}`)
    }
    if (parsedParams && parsedParams['s'] && parsedParams['s'] === 'true') {
      setFilters()
    }
  }, [])
  useEffect(() => {
    if (!tmpSearch) {
      setSearch(null)
    }
  }, [tmpSearch])

  useEffect(() => {
    console.log('UE', (selectedConversation || {} as any).customFields)
    if (!selectedConversation || (!selectedConversation.customFields.find(x => x.id === 18618) && !selectedConversation.customFields.find(x => x.name === 'Patient ID'))) return
    // console.log('UE found', selectedConversation.customFields.find(x => x.id === 18618))
    let id = ''
    const byName = selectedConversation.customFields.find(x => x.name === 'Patient ID')
    const byId = selectedConversation.customFields.find(x => x.id === 18618)

    if (byName) {
      id = byName.value
    } else if (byId) {
      id = byId.value
    }

    if (!!id) {
      loadPatient({
        variables: {
          id
        }
      })
    }
  }, [selectedConversation])

  const onTriggerSearch = () => {
    setSearch(tmpSearch)
  }

  const onSelectConversation = (conversation: IConversationListEntry) => {
    console.log('onSelectConvo', { conversation, selectedConversation })
    setnavigatedConversation(null)
    if (!selectedConversation) {
      setselectedConversation(conversation)
      return
    }

    if (selectedConversation.id === conversation.id) {
      setselectedConversation(null)
      navigate(`/messages`)
      return
    }
    setselectedConversation(conversation)
  }

  return (
    <Container flexDirection={'row'} style={{ height: '100%', maxHeight: '100%' }} overflowY={['hidden']}>

      <Flex flexDirection={'column'} style={{ height: '100%', maxHeight: '100%' }} overflowY={['auto', 'hidden', 'hidden']} flex={1}
        paddingTop={`${Constants.OUTLETS_PADDING_TOP}px`}>
        <Flex flexDirection={['column', 'row', 'row']} alignItems={'center'}>
          {!selectedConversation && !params['*'] ? (
            <>
              <Heading ml={2} mr={3}>Messages</Heading>
              <Flex style={{ background: 'white', borderRadius: '12px', padding: '0 12px', height: '50px', overflow: "hidden", width: '330px' }} alignItems='center'
                onClick={() => {
                }}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                  <path d="M21 21L16.514 16.506L21 21ZM19 10.5C19 12.7543 18.1045 14.9163 16.5104 16.5104C14.9163 18.1045 12.7543 19 10.5 19C8.24566 19 6.08365 18.1045 4.48959 16.5104C2.89553 14.9163 2 12.7543 2 10.5C2 8.24566 2.89553 6.08365 4.48959 4.48959C6.08365 2.89553 8.24566 2 10.5 2C12.7543 2 14.9163 2.89553 16.5104 4.48959C18.1045 6.08365 19 8.24566 19 10.5V10.5Z" stroke="#344F7A" stroke-width="2" stroke-linecap="round" />
                </svg>
                <InputNoForm type="search"
                  autoFocus
                  onChange={(e: any) => {
                    setTmpSearch(e.target.value)
                  }}
                  onReturn={onTriggerSearch}
                  style={{ backgroundColor: 'white', border: '0px', flex: 1, paddingTop: '12px', paddingBottom: '12px' }}
                  value={tmpSearch}
                  containerStyle={{ flex: 1 }}
                  placeholder='search by first or last name' />

              </Flex></>
          ) : (<>
            <svg style={{ marginTop: '12px', marginLeft: '12px', alignSelf: 'baseline' }} onClick={async () => {
              setselectedConversation(null)
              await sleep(100)
              navigate('/messages')
            }} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 11H7.14L10.77 6.64C10.9397 6.43578 11.0214 6.1725 10.997 5.90808C10.9726 5.64365 10.8442 5.39974 10.64 5.23C10.4358 5.06026 10.1725 4.9786 9.90808 5.00298C9.64365 5.02736 9.39974 5.15578 9.23 5.36L4.23 11.36C4.19636 11.4077 4.16628 11.4579 4.14 11.51C4.14 11.56 4.14 11.59 4.07 11.64C4.02467 11.7547 4.00094 11.8767 4 12C4.00094 12.1233 4.02467 12.2453 4.07 12.36C4.07 12.41 4.07 12.44 4.14 12.49C4.16628 12.5421 4.19636 12.5923 4.23 12.64L9.23 18.64C9.32402 18.7529 9.44176 18.8437 9.57485 18.9059C9.70793 18.9681 9.85309 19.0002 10 19C10.2337 19.0005 10.4601 18.9191 10.64 18.77C10.7413 18.6861 10.825 18.583 10.8863 18.4666C10.9477 18.3503 10.9855 18.223 10.9975 18.092C11.0096 17.961 10.9957 17.8289 10.9567 17.7033C10.9176 17.5777 10.8542 17.461 10.77 17.36L7.14 13H19C19.2652 13 19.5196 12.8946 19.7071 12.7071C19.8946 12.5196 20 12.2652 20 12C20 11.7348 19.8946 11.4804 19.7071 11.2929C19.5196 11.1054 19.2652 11 19 11Z" fill="#344f79" />
            </svg>

            <Heading ml={2} mr={3} display={['none!important', 'flex !important', 'flex !important']}>Messages</Heading>
            <Flex display={['none!important', 'flex !important', 'flex !important']} style={{ background: 'white', borderRadius: '12px', padding: '0 12px', height: '50px', overflow: "hidden", width: '330px' }} alignItems='center'
              onClick={() => {
              }}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                <path d="M21 21L16.514 16.506L21 21ZM19 10.5C19 12.7543 18.1045 14.9163 16.5104 16.5104C14.9163 18.1045 12.7543 19 10.5 19C8.24566 19 6.08365 18.1045 4.48959 16.5104C2.89553 14.9163 2 12.7543 2 10.5C2 8.24566 2.89553 6.08365 4.48959 4.48959C6.08365 2.89553 8.24566 2 10.5 2C12.7543 2 14.9163 2.89553 16.5104 4.48959C18.1045 6.08365 19 8.24566 19 10.5V10.5Z" stroke="#344F7A" stroke-width="2" stroke-linecap="round" />
              </svg>
              <InputNoForm type="search"
                autoFocus
                onChange={(e: any) => {
                  setTmpSearch(e.target.value)
                }}
                onReturn={onTriggerSearch}
                style={{ backgroundColor: 'white', border: '0px', flex: 1, paddingTop: '12px', paddingBottom: '12px' }}
                value={tmpSearch}
                containerStyle={{ flex: 1 }}
                placeholder='search by first or last name' />

            </Flex>
          </>)}
        </Flex>
        <Box mt={['6px', '20px', '20px']} mb={['6px', '20px', '20px']} width={'100%'} height='0px' backgroundColor={'#C9C9C9'} minHeight='0px' />
        <Flex flex={1} maxHeight={['', 'calc(100% - 80px)', 'calc(100% - 80px)']}>
          <ListContainer className={params && params['*'] ? 'selected' : ''}>
            <Card style={{
              flex: 'initial',
              minWidth: !selectedConversation && !params['*'] ? '100%' : '350px',
              maxWidth: !selectedConversation && !params['*'] ? '100%' : '350px',
              height: '100%',
              borderRadius: '30px',
              overflow: 'hidden',
              display: 'flex'
            }}>
              {!search ? (
                <MessagesListNoSearch onSelectConversation={onSelectConversation} />
              ) : (
                <MessagesListSearch onSelectConversation={onSelectConversation} search={search} />
              )}

            </Card>
          </ListContainer>
          <DetailContainer id='detailContainer' className={params && params['*'] ? 'selected' : ''}>
            {params && params['*'] ? (
              <Card ml={[0, 3]} minWidth={['100%', !selectedConversation && !navigatedConversation && !params['*'] ? '0' : '450px', !selectedConversation && !navigatedConversation && !params['*'] ? '0' : '450px']} style={{
                flex: 1,
                height: '100%',
                borderRadius: '30px',
                overflow: 'hidden',
                width: !selectedConversation && !navigatedConversation && !params['*'] ? '0' : '',
                maxWidth: !selectedConversation && !navigatedConversation && !params['*'] ? '0' : '',
              }}>
                <Communicator conversationId={navigatedConversation || params['*']} onSelectConversation={setnavigatedConversation} />
              </Card>
            ) : (
              <Flex ml={3} minWidth={['100%', !selectedConversation && !params['*'] ? '0' : '450px', !selectedConversation && !params['*'] ? '0' : '450px']} style={{
                flex: 1,
                height: '100%',
                borderRadius: '30px',
                overflow: 'hidden',
                justifyContent: 'center',
                alignItems: 'center'
              }}>
                <Heading>Select a conversation on the left</Heading>
              </Flex>
            )}
          </DetailContainer>
        </Flex>
      </Flex>


      <PatientDetailsFloatingContainer id='pdfc'>
        {((!!dataPatient && dataPatient.getProviderPatientById) && (!!selectedConversation || !!params['*'])) && (
          <ProfileCardSection patient={dataPatient.getProviderPatientById} />
        )}
      </PatientDetailsFloatingContainer>
      {((!!dataPatient && dataPatient.getProviderPatientById) && (!!selectedConversation || !!params['*'])) && (
        <PatientDetailsContainer id='pdc'>
          <Box style={{ height: '100vh', flex: 1, position: 'sticky', top: 0 }}>
            <Box style={{ height: '100%', background: '#C0CDEC', flex: 1, borderRadius: '20px' }}>
              <PatientEmbed athenaId={dataPatient.getProviderPatientById.athenaId} />
            </Box>
          </Box>
        </PatientDetailsContainer>
      )}
    </Container>);
}